import React from 'react'
import DropDownFilter from './dropdown-filter'
import useLocations from '../../../hooks/use-locations'
import { get } from 'lodash'

const LocationFilter = ({
    value = {},
    onChange = () => {},
    disabled
}) => {
    const [ locations ] = useLocations()
    return (
        <React.Fragment>
            <DropDownFilter
                items={locations}
                title='Location'
                onChange={l => onChange({ ...value, locations: l})}
                values={get(value, 'locations', [])}
                disabled={disabled}
            />
        </React.Fragment>
    )
}

export default LocationFilter